import { useRestQuery } from 'utils/hooks/api';

export const FETCH_PERMISSIONS_URL = '/i/permissions';

export const usePermissionsQuery = () => useRestQuery(FETCH_PERMISSIONS_URL);

export type Permission = {
  category: string;
  id: number;
  name: string;
  requires: number[];
  scope: string;
};
